module.exports = __webpack_public_path__ + "static/media/018.4fb8c7f6.jpg";